// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-mail-magazine-check-list[data-v-5f87d980]{padding-left:0}", ""]);
// Exports
module.exports = exports;
